'use client';

import { PropsWithChildren } from 'react';

import Header from './Header';
import Notifications from './Notifications';

const Content = ({ children, className }: PropsWithChildren & React.HTMLAttributes<HTMLDivElement>) => {
	return (
		<div className={`w-full p-4 bg-[rgba(0, 0, 0, 0.06)] flex flex-col gap-4  ${className || ''}`}>{children}</div>
	);
};

Content.Header = Header;
Content.Notifications = Notifications;

export default Content;
